import { StudentGroupConstant } from "./constant";

export const openModal = () => ({
  type: StudentGroupConstant.STUDENT_GROUP_OPEN,
});

export const updateStudentGroup = (returnedPayload) => ({
  type: StudentGroupConstant.UPDATE_STUDENT_GROUP,
  payload: returnedPayload,
});
export const setStudentGroupData = (returnedPayload) => ({
  type: StudentGroupConstant.SET_GROUP_DATA,
  payload: returnedPayload,
});

export const setClassIdByData = (returnedPayload) => ({
  type: StudentGroupConstant.SET_CLASSID_BY_DATA,
  payload: returnedPayload,
});

export const updateGroupData = (returnedPayload) => ({
  type: StudentGroupConstant.UPDATE_GROUP_DATA,
  payload: returnedPayload,
});
export const DeleteStudentGroupData = (returnedPayload) => ({
  type: StudentGroupConstant.DELTE_GROUP_DATA,
  payload: returnedPayload,
});
